import React from 'react';


function CssCounter(props) {
	
	const seconds = props.seconds;
	
	let styleKeyframe = '@keyframes countdown {';
	for(let i = 0; i <= seconds; i++){
		let percentage = (i*100)/seconds;
		percentage = percentage + '';
		percentage = percentage.split('.')[0];
		styleKeyframe = styleKeyframe +  percentage + '% {';
		styleKeyframe = styleKeyframe + 'counter-reset: s ' + (seconds - i) + ';';
		styleKeyframe = styleKeyframe + "} ";
	}
	styleKeyframe = styleKeyframe + '}';
	
	const styleAfter = `
		.remainingSeconds::after {
		    animation: countdown ${seconds}s steps(1);
		 	content: counter(s);
		 	margin-left:5px;
		 }
	`;


    return <> 
         <div ref={props.refCartLoader} className="bouncing-cart-loader">
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div ref={props.refLoaderLabel} className="loader-label"> 
        {props.label} <span className="remainingSeconds"></span>...
        </div>
        
    	<style> { styleKeyframe + styleAfter} </style>
    </>;
}

export default CssCounter;
